import { DiskView } from "@/modules/disks/disk/DiskView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/disks/disk/$location/$uuid/")({
    component: Component,
});

function Component() {
    const { uuid, location } = Route.useParams();
    // NB: `key` prop ensures that the component state is reset when the route changes (to prevent eg. `isOpen` etc. states from remaining the same)
    return <DiskView key={uuid} location={location} diskId={uuid} />;
}
